const MeetData = [
    {content:"Built with background and side noise suppression"},
    {content:"Pick any virtual background or use a template"},
    {content:"Immersive reactions and emojis to express yourself"},
    {content:"Built in security; for any type of private meeting"},
    {content:"Auto-adjusting light so you look your best every time"},
]
export default MeetData;